var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-report-wrapper" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "left-content" }, [
          _c("div", { staticClass: "name" }, [_vm._v("待办事项")]),
          _vm._v(" "),
          _c("div", { staticClass: "data-info" }, [
            _c("div", [
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      return _vm.goToPage(1)
                    }
                  }
                },
                [_vm._v("待处理订单")]
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { color: "#f00" } }, [
                _vm._v(_vm._s(_vm.databoardData.order_nd_num))
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      return _vm.goToPage(2)
                    }
                  }
                },
                [_vm._v("待处理售后单")]
              ),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.databoardData.as_order_ne_num))])
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      return _vm.goToPage(3)
                    }
                  }
                },
                [_vm._v("待处理工单")]
              ),
              _vm._v(" "),
              _c("div", [
                _vm._v(_vm._s(_vm.databoardData.as_order_wo_num.total))
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      return _vm.goToPage(4)
                    }
                  }
                },
                [_vm._v("库存缺货")]
              ),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.databoardData.stock_warn_num))])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showWarnData,
                expression: "showWarnData"
              }
            ],
            staticClass: "right-content-style",
            staticStyle: { "padding-left": "30px" }
          },
          [
            _c("div", { staticClass: "name" }, [_vm._v("异常订单数据展示")]),
            _vm._v(" "),
            _c("div", { staticClass: "data-info" }, [
              _c("div", [
                _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        return _vm.goToPage(5)
                      }
                    }
                  },
                  [_vm._v("超时未到分仓")]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(_vm._s(_vm.databoardData.order_to_num) + "(单)")
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        return _vm.goToPage(6)
                      }
                    }
                  },
                  [_vm._v("售后单超时未到分仓")]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(_vm._s(_vm.databoardData.as_order_to_num) + "(单)")
                ])
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "data-wrapper" }, [
        _c("div", { staticClass: "data-header bottom-style" }, [
          _c("span", [_vm._v("数据展示")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "（统计时间：" +
                _vm._s(
                  _vm.datareportDateList[_vm.datareportDateList.length - 1]
                ) +
                "）"
            )
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("按自然日来统计")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "data-content" }, [
          _c(
            "div",
            {
              class: { "active-data": _vm.activeEchartIndex === 1 },
              on: {
                click: function($event) {
                  return _vm.loadEchartData(1)
                }
              }
            },
            [
              _c(
                "div",
                [
                  _vm._v("\n          及时出库率\n          "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: "系统发货时间内发货的订单数/有效推单数；",
                        placement: "top"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(_vm.dg_order_rate[_vm.dg_order_rate.length - 1]) + "%"
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: { "active-data": _vm.activeEchartIndex === 2 },
              on: {
                click: function($event) {
                  return _vm.loadEchartData(2)
                }
              }
            },
            [
              _c(
                "div",
                [
                  _vm._v("\n          拒单率\n          "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: "店铺拒单的子单数量/非客户取消的子单数量；",
                        placement: "top"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(_vm.rs_order_rate[_vm.rs_order_rate.length - 1]) + "%"
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: { "active-data": _vm.activeEchartIndex === 3 },
              on: {
                click: function($event) {
                  return _vm.loadEchartData(3)
                }
              }
            },
            [
              _c(
                "div",
                [
                  _vm._v("\n          当月缺货率\n          "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: "库存预警的SKU数 / 店铺启用SKU数；",
                        placement: "top"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(_vm.sw_goods_rate[_vm.sw_goods_rate.length - 1]) + "%"
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showWarnData,
                  expression: "showWarnData"
                }
              ],
              class: { "active-data": _vm.activeEchartIndex === 4 },
              on: {
                click: function($event) {
                  return _vm.loadEchartData(4)
                }
              }
            },
            [
              _c(
                "div",
                [
                  _vm._v("\n          售后及时处理率\n          "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content:
                          "一定时效内(出库后自然日两天)处理的售后订单数/总售后订单数(当月全量)",
                        placement: "top"
                      }
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.hd_as_order_rate[_vm.hd_as_order_rate.length - 1]
                  ) + "%"
                )
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right-data" }, [
        _c(
          "span",
          {
            class: { "active-tab": _vm.activeDate === 1 },
            on: {
              click: function($event) {
                return _vm.loadDateData(1)
              }
            }
          },
          [_vm._v("近7天")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            class: { "active-tab": _vm.activeDate === 2 },
            on: {
              click: function($event) {
                return _vm.loadDateData(2)
              }
            }
          },
          [_vm._v("近30天")]
        )
      ]),
      _vm._v(" "),
      _c("div", { attrs: { id: "container" } }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "data-dialog",
          attrs: {
            visible: _vm.dialogVisible,
            width: "50%",
            center: "",
            "append-to-body": true,
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title"
            },
            [
              _vm._v(
                "\n      待处理工单：" +
                  _vm._s(_vm.databoardData.as_order_wo_num.total) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "title-tip" }, [
            _c(
              "div",
              {
                on: {
                  click: function($event) {
                    return _vm.goToPage(7)
                  }
                }
              },
              [
                _vm._v(
                  "\n        我创建的：" +
                    _vm._s(_vm.databoardData.as_order_wo_num.mc) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                on: {
                  click: function($event) {
                    return _vm.goToPage(8)
                  }
                }
              },
              [
                _vm._v(
                  "\n        我受理的：" +
                    _vm._s(_vm.databoardData.as_order_wo_num.mh) +
                    "\n      "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "left-content" }, [
              _c("div", [
                _c("span", [
                  _vm._v(
                    "已处理：" +
                      _vm._s(_vm.databoardData.as_order_wo_num.mc_ycl)
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "新建：" + _vm._s(_vm.databoardData.as_order_wo_num.mc_new)
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", [
                  _vm._v(
                    "开始处理：" +
                      _vm._s(_vm.databoardData.as_order_wo_num.mc_kcl)
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "驳回处理：" +
                      _vm._s(_vm.databoardData.as_order_wo_num.mc_back)
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "right-content" }, [
              _c("div", [
                _c("span", [
                  _vm._v(
                    "新建：" + _vm._s(_vm.databoardData.as_order_wo_num.mh_new)
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "驳回处理：" +
                      _vm._s(_vm.databoardData.as_order_wo_num.mh_back)
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", [
                  _vm._v(
                    "已处理：" +
                      _vm._s(_vm.databoardData.as_order_wo_num.mh_ycl)
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("NoticeDialog")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4f1714a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4f1714a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dataReport/dataReport.vue
// module id = null
// module chunks = 